import React from "react";
import { useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import axiosHandler from "../../../utils/axiosHandler.ts";
import { OrderEntryPage } from "../../../federation/pages";

const CreateOrder = () => {
  const navigate = useNavigate();

  return (
    <React.Suspense fallback={<CircularProgress />}>
      <OrderEntryPage axiosHandler={axiosHandler} navigate={navigate} />
      {/* <OrderEntryPage /> */}
    </React.Suspense>
  );
};

export default CreateOrder;
